import HtmlUtils from "lib/HtmlUtils";

export enum SidebarMessageKeys {
    RESET = '@@SidebarMessageKeys/RESET',
}

export interface SidebarReset {
    readonly type: SidebarMessageKeys.RESET;
}

export type SidebarMessageTypes =
    | SidebarReset;


export class SidebarPostWindowMessages {
    private location: string;

    constructor(private window: Window) {
        this.location = HtmlUtils.getFullLocation();
    }

    reset() {
        // Envia a mensagem para todas as janelas que foram abertas.
        var w = this.window;
        do {
            w.postMessage({ type: SidebarMessageKeys.RESET }, this.location)
            w = w.opener;
        } while (w != null)
    }
}
